import { render, staticRenderFns } from "./wechatHome.vue?vue&type=template&id=9a954978&scoped=true&"
import script from "./wechatHome.vue?vue&type=script&lang=js&"
export * from "./wechatHome.vue?vue&type=script&lang=js&"
import style0 from "./wechatHome.vue?vue&type=style&index=0&id=9a954978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a954978",
  null
  
)

export default component.exports